import { useMutation, UseMutationResult } from "@tanstack/react-query";

import { useOrderService } from "contexts/ServiceContext";
import { ApiStatusException } from "services/apiErrors";
import { AI_EVENTS, useTrackEvent } from "../../useAppInsight";

const useOrderFiles = (): UseMutationResult<
  DocumentsFile[] | undefined,
  ApiStatusException,
  number | undefined
> => {
  const ordersService = useOrderService();
  const trackQuery = useTrackEvent(AI_EVENTS.API_REQUEST);
  const trackQueryError = useTrackEvent(AI_EVENTS.API_ERROR);

  return useMutation({
    mutationKey: ["document-files", "orders"],
    mutationFn: (docEntry) => {
      const eventId = trackQuery({
        endpoint: "Order/GetFileUriList/{DocEntry}",
        parameters: {
          docEntry,
        },
      });
      return docEntry
        ? ordersService
            .getReleaseFileList(docEntry)
            .then((data) => data.value)
            .catch((err) => {
              trackQueryError(
                {
                  statusCode: err.statusCode,
                  message: err.message,
                },
                eventId
              );
              throw err;
            })
        : Promise.reject();
    },
  });
};

export default useOrderFiles;
